<template>
  <v-container>
    <v-dialog v-model="openFlag" persistent max-width="1000px">
      <c-card class="white" title="바우처 반환">
        <v-divider class="mt-3 mb-3"></v-divider>
        <v-form lazy-validation ref="form">
          <v-container>
            <c-table :headers="tableHeader" :items="selected" itemKey="id">
              <template #name="{item}">
                {{ item.name }}
              </template>
              <template #customerName="{item}">
                {{ item.customerName }}
              </template>
              <template #issueDate="{item}">
                {{ item.issueDate ? $func.dateToString(item.issueDate) : "" }}
              </template>
              <template #expirationDate="{item}">
                {{
                  item.expirationDate
                    ? $func.dateToString(item.expirationDate)
                    : ""
                }}
              </template>
              <template #remainCnt="{item}">
                {{ item.remainCnt }}
              </template>
              <template #returnCnt="{item}">
                <v-text-field
                  v-mask="['#', '##', '###']"
                  v-model="item.returnCnt"
                  solo
                  dense
                  hide-details
                  color="navy"
                ></v-text-field>
              </template>
            </c-table>

            <v-row justify="center">
              <c-btn
                class="mr-1 mt-2"
                color="blue"
                outlined
                @click="reqBackVoucher"
                >확인</c-btn
              >
              <c-btn
                class="mt-2"
                color="gray"
                outlined
                @click="openFlag = false"
                >취소</c-btn
              >
            </v-row>
          </v-container>
        </v-form>
      </c-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mask } from "vue-the-mask";

export default {
  directives: { mask },

  props: {
    open: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Array,
    },
  },

  data: () => ({
    openFlag: false,

    tableHeader: [
      {
        text: "바우처 명",
        value: "name",
        align: "center",
        sortable: false,
      },
      {
        text: "발급 대상",
        value: "customerName",
        align: "center",
        sortable: false,
      },
      {
        text: "지급일",
        value: "issueDate",
        align: "center",
        sortable: false,
      },
      {
        text: "만료일",
        value: "expirationDate",
        align: "center",
        sortable: false,
      },
      {
        text: "남은 개수",
        value: "remainCnt",
        align: "center",
        sortable: false,
      },
      {
        text: "반환 개수",
        value: "returnCnt",
        align: "center",
        sortable: false,
      },
    ],
  }),
  watch: {
    open(value) {
      this.openFlag = value;
    },
    openFlag(value) {
      this.$emit("update:open", value);
    },
  },
  methods: {
    reqBackVoucher() {
      for (const idx in this.selected) {
        if (
          Number(this.selected[idx].remainCnt) <
          Number(this.selected[idx].returnCnt)
        ) {
          this.$store.commit("snackbar", {
            timeout: 2000,
            msg: "남은 개수보다 반환 개수가 더 많습니다.",
          });
          return;
        }

        if (
          Number(this.selected[idx].returnCnt) < 1 ||
          !this.selected[idx].returnCnt
        ) {
          this.$store.commit("snackbar", {
            timeout: 2000,
            msg: "1 이상의 반환 개수를 입력해주십시오.",
          });
          return;
        }
      }

      for (const idx in this.selected) {
        this.selected[idx].remainCnt =
          Number(this.selected[idx].remainCnt) -
          Number(this.selected[idx].returnCnt);
        this.selected[idx].backCnt =
          Number(this.selected[idx].backCnt) +
          Number(this.selected[idx].returnCnt);
      }

      this.$emit("reqBackVoucher", this.selected);
    },
  },
};
</script>
